// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import Checkboxes from '../../../utils/FormWidgets/Checkboxes';

const StyledWrapper = styled.div`
    border: 1px solid #ccc;
    padding: 6px; 12px;
`;

const WEEK_DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const ActivityAvailableWeekDays = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  value,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onMetaFieldsChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  initialValue,
}) => {
  const [selectedDays, setSelectedDays] = useState([]);

  const onDayClick = event => {
    const day = event.target.value;
    let updatedDays = [...selectedDays];
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (selectedDays.includes(day)) {
      updatedDays = updatedDays.filter(d => d !== day);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      updatedDays.push(day);
    }
    updatedDays.sort((a, b) => WEEK_DAYS.indexOf(a) - WEEK_DAYS.indexOf(b));
    setSelectedDays(updatedDays);
    onMetaFieldsChange([{ name: 'hours', value: updatedDays.join(',') }]);
  };

  useEffect(() => {
    if (initialValue !== value) return;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (value && !value.startsWith('BEGIN:VCALENDAR')) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      const days = value.split(',').map(item => item.toUpperCase().trim());
      setSelectedDays(days);
    }
  }, [value]);

  return (
    <StyledWrapper>
      {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        <Checkboxes
          label={label}
          options={WEEK_DAYS.map(d => ({ value: d, label: d }))}
          onChange={onDayClick}
          values={selectedDays}
        />
      }
    </StyledWrapper>
  );
};

export default ActivityAvailableWeekDays;
